import React from "react";
import Table, {
  AvatarCell,
  SelectColumnFilter,
  StatusPill,
} from "../components/table";
import Footer from "../components/footer";
import { useEffect, useState, useRef } from "react";
import { updateRoleApi, manageApi } from "../services/manage";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import NavBar from "../components/navbar";

//Main manage panel function
const ManagePanel = () => {
  const [userData, setData] = useState<
    { id: number; name: string; email: string; role: string; phone: string }[]
  >([]);
  //Set a state to tell the component it need to wait until the result is fetched from the api
  const [loadingData, setLoadingData] = useState(true);
  const [newRole, setRole] = useState("");
  const prevRole = useRef("");

  useEffect(() => {
    prevRole.current = newRole;
  }, [newRole]);

  //Handle onClick Update
  const onClickHandler = async (id: number, current_role: string) => {
    if (current_role == prevRole.current) {
      toast.error("No changes to new role");
    } else if (prevRole.current == "") {
      toast.error("No changes to be made ");
    } else {
      try {
        const response = await updateRoleApi(id, prevRole.current);
        if (response.status === 200) {
          toast.error("Update Success");
        }
      } catch (e) {
        if (
          e instanceof AxiosError &&
          e.response &&
          e.response.status === 403
        ) {
          toast.error("Invalid Request");
        }
      }
    }
  };

  //Handle role dropdown
  const RoleDropdown = (role: any) => {
    return (
      <div style={{ display: "flex" }}>
        <select
          defaultValue={role.role} //Set default value to display the current role
          onChange={(e) => {
            //Get value on changed, this is not guaranteed to be the updated during on click
            setRole(e.target.value);
          }}
        >
          <option value="user">user</option>
          <option value="admin">admin</option>
        </select>
      </div>
    );
  };

  useEffect(() => {
    const loadUserList = async () => {
      const userLists = await manageApi();
      if (userLists) {
        if (userLists.users.length > 0) {
          userLists.users.forEach((user: any) => {
            var items = {
              id: user[0],
              name: user[1],
              email: user[2],
              role: user[3],
              phone: user[4],
            };
            setData((prevData) => [...prevData, items]);
          });
        }
        setLoadingData(false); //Set loadingData to false to tell the component that the result is fetched
      }
    };
    if (loadingData) {
      loadUserList();
    }
  }, []);
  const data = React.useMemo(() => userData, [userData]);
  const columns = React.useMemo(
    () => [
      {
        Header: "Id",
        accessor: "id",
      },
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Email",
        accessor: "email",
      },
      {
        Header: "Phone Number",
        accessor: "phone",
      },
      {
        Header: "Role",
        accessor: "role",
        Filter: SelectColumnFilter, // new
        filter: "includes",
        Cell: (accessor: any) => {
          return <RoleDropdown role={accessor.value} />;
        },
      },
      {
        Header: "Action",
        Cell: (props: any) => (
          <button
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
            onClick={() =>
              onClickHandler(props.row.original.id, props.row.original.role)
            }
          >
            Update
          </button>
        ),
      },
    ],
    []
  );

  return (
    <div className="Manage">
      <NavBar />
      {loadingData ? (
        <p className="grid h-screen place-items-center">
          Data Loading Please Wait...
        </p>
      ) : (
        <div className="min-h-screen bg-white-100 text-gray-900 mt-20 mb-20">
          <main className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-4">
            <div className="">
              <h1 className="text-xl font-semibold">Manage Accounts</h1>
            </div>
            <div className="mt-6">
              <Table columns={columns} data={data} />
            </div>
          </main>
        </div>
      )}
      <Footer />
    </div>
  );
};

export default ManagePanel;
